/**
 * sort metadata class for grids
 */
export default class SortData {
  constructor(field, order) {
    this.field = field
    this.order = order
  }

  getField() {
    return this.field
  }

  getOrder() {
    return this.order
  }
}
